// extracted by mini-css-extract-plugin
export var modalContainer = "AcceptModal-module--modalContainer--d-ZG5";
export var modalContent = "AcceptModal-module--modalContent--JG8cP";
export var titleContainer = "AcceptModal-module--titleContainer--RWY9L";
export var errorTitle = "AcceptModal-module--errorTitle--8pWbR";
export var successTitle = "AcceptModal-module--successTitle--JcI0K";
export var closeButton = "AcceptModal-module--closeButton--FxzQm";
export var content = "AcceptModal-module--content--fyDdx";